/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  GetUsersParams,
  IRBUserProtocolsResponse,
  UserCreate,
  UserListResponse,
  UserPatch,
  UserPut,
  UserResponse,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({providedIn: 'root'})
export class UsersService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Set query param `is_admin` to True to get list of admin users
   * @summary Get Users
   */
  getUsers<TData = UserListResponse>(params?: GetUsersParams, options?: HttpClientBodyOptions): Observable<TData>;
  getUsers<TData = UserListResponse>(
    params?: GetUsersParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getUsers<TData = UserListResponse>(
    params?: GetUsersParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getUsers<TData = UserListResponse>(
    params?: GetUsersParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/users`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/users`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/users`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Creates a new user
   * @summary Create User
   */
  createUser<TData = unknown | void>(userCreate: UserCreate, options?: HttpClientBodyOptions): Observable<TData>;
  createUser<TData = unknown | void>(
    userCreate: UserCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createUser<TData = unknown | void>(
    userCreate: UserCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createUser<TData = unknown | void>(
    userCreate: UserCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/users`, userCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/users`, userCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/users`, userCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets data for user. Use `me` to get data for the current user.
   * @summary Get User
   */
  getUser<TData = UserResponse>(userId: 'me' | string, options?: HttpClientBodyOptions): Observable<TData>;
  getUser<TData = UserResponse>(userId: 'me' | string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getUser<TData = UserResponse>(
    userId: 'me' | string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getUser<TData = UserResponse>(
    userId: 'me' | string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/users/${userId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/users/${userId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/users/${userId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Patches an existing user. This endpoint allows updates by sending a single field to update in the request
   * body. Use `me` to patch the current user. Non-admin users cannot modify their role.
   * @summary Patch User
   */
  patchUser<TData = unknown | void>(
    userId: 'me' | string,
    userPatch: UserPatch,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  patchUser<TData = unknown | void>(
    userId: 'me' | string,
    userPatch: UserPatch,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  patchUser<TData = unknown | void>(
    userId: 'me' | string,
    userPatch: UserPatch,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  patchUser<TData = unknown | void>(
    userId: 'me' | string,
    userPatch: UserPatch,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(`${this.baseUrl}/users/${userId}`, userPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(`${this.baseUrl}/users/${userId}`, userPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.patch<TData>(`${this.baseUrl}/users/${userId}`, userPatch, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Updates an existing user. Use `me` to update the current user. Non-admin users cannot modify their role.
   * @summary Update User
   */
  updateUser<TData = unknown | void>(
    userId: 'me' | string,
    userPut: UserPut,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateUser<TData = unknown | void>(
    userId: 'me' | string,
    userPut: UserPut,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateUser<TData = unknown | void>(
    userId: 'me' | string,
    userPut: UserPut,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateUser<TData = unknown | void>(
    userId: 'me' | string,
    userPut: UserPut,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/users/${userId}`, userPut, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/users/${userId}`, userPut, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/users/${userId}`, userPut, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets a list of IRB protocols (IRB study IDs) with which the requesting user has approval
   * @summary Get User Irb Protocols
   */
  getUserIRBProtocols<TData = IRBUserProtocolsResponse[]>(
    userId: 'me' | string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getUserIRBProtocols<TData = IRBUserProtocolsResponse[]>(
    userId: 'me' | string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getUserIRBProtocols<TData = IRBUserProtocolsResponse[]>(
    userId: 'me' | string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getUserIRBProtocols<TData = IRBUserProtocolsResponse[]>(
    userId: 'me' | string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/users/${userId}/irb-protocols`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/users/${userId}/irb-protocols`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/users/${userId}/irb-protocols`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
